import { dataHooks } from '@wix/data-hooks';

export const headerDataHooks = dataHooks<{
  root: {};
  content: {};
  title: {};
  description: {};
  locationButton: {};
  statusBar: {};
}>('header');
